export default __webpack_public_path__ + "static/media/view_more.a12707ad.svg";